import {
    Component,
    EventEmitter,
    Output,
    ViewChild,
    Input
} from "@angular/core";

import { GoogleMapsProvider } from "../../providers/google-maps/google-maps";

/**
 * Generated class for the GoogleMapsComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */

declare var adsbygoogle;

@Component({
    selector: "google-ads",
    templateUrl: "google-ads.html",
    styleUrls:['./google-ads.scss']
})
export class GoogleAdsComponent {



    constructor() {

    }
}
